import { defineMessages, useIntl } from 'react-intl';
import { InputCurrency } from '@packages/shared/src/ui/Input/InputCurrency';
import { Button } from '@packages/shared/src/ui/Button/Button';
import { useFormContext } from 'react-hook-form';
import { furtherInformationMessages, generalFormMessages } from './messages';
import type { CreditCheckFormValues } from './schema';
import type { OpenDialogHandler } from './types';

export const messages = defineMessages({
  monthlyIncomeInputInfo: {
    id: 'CreditCheckForm.ShortFormSection.InputInfo',
    defaultMessage:
      'Naast je salaris of uitkering, kan je inkomen ook bestaan uit huuropbrengsten, lijfrenten of ontvangen alimentatie. Ook bonussen worden meegeteld. Neem het totale bonusbedrag dat je jaarlijks ontvangt en deel dit door 12 maanden.',
  },
});

type ShortFormSectionProps = {
  handleOpenDialog: OpenDialogHandler;
};

export const ShortFormSection: React.FC<ShortFormSectionProps> = ({ handleOpenDialog }) => {
  const { formatMessage } = useIntl();
  const {
    register,
    formState: { errors },
  } = useFormContext<CreditCheckFormValues<'short'>>();

  return (
    <div className="flex flex-col gap-1.5" data-testid="short-form-section">
      <div className="flex items-center md:w-1/2">
        <InputCurrency
          {...register('secondPartForm.monthlyIncome')}
          label={formatMessage(furtherInformationMessages.monthlyIncome, {
            // display the asterisk in the label, but not in the dialog title
            asterisk: (chunks) => chunks,
          }).toString()}
          containerClassName="relative w-full"
          placeholder={formatMessage(generalFormMessages.inputPlaceholder)}
          error={!!errors?.secondPartForm?.monthlyIncome?.message}
          helperText={errors?.secondPartForm?.monthlyIncome?.message}
          currencyPosition="left"
        />
      </div>
      <Button
        variant="link"
        size="base"
        className="text-size-body3 items-center justify-start px-0 py-0"
        onClick={(e) =>
          handleOpenDialog(
            furtherInformationMessages.monthlyIncome,
            furtherInformationMessages.monthlyIncomeDialogText,
            e,
          )
        }
      >
        {formatMessage(furtherInformationMessages.furtherInformationCardLink)}
      </Button>
      <div className="border-color-grey-dark rounded-md border border-opacity-50 p-1.5">
        {formatMessage(messages.monthlyIncomeInputInfo)}
      </div>
    </div>
  );
};
